export default __webpack_public_path__ + "static/media/o_logo.0d990b3d.svg";